export const FILE_TYPES = {
  image: "image/*",
  video: "video/*",
  audio: "audio/*",
  application: "application/*",
  allTypes: "image/*,video/*,audio/*,application/*",
};
